import { render, staticRenderFns } from "./CadastroPacoteDeSessoes.vue?vue&type=template&id=2466d293&"
import script from "./CadastroPacoteDeSessoes.vue?vue&type=script&lang=js&"
export * from "./CadastroPacoteDeSessoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports